module.exports = __webpack_public_path__ + "img/pageBanner-DocumentDownload.737cd6b4.jpg";